import { useEffect } from 'react'

let suppressedUntil = 0

export function suppressLeavePageConfirmation(durationMs = 8000) {
  suppressedUntil = Date.now() + durationMs
}

export function useLeavePageConfirmation(enabled: boolean, message: string) {
  useEffect(() => {
    if (!enabled) return

    const handler = (event: BeforeUnloadEvent) => {
      if (Date.now() < suppressedUntil) return

      event.preventDefault()
      event.returnValue = message
      return message
    }

    window.addEventListener('beforeunload', handler)
    return () => {
      window.removeEventListener('beforeunload', handler)
    }
  }, [enabled, message])
}
